import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=9dc5d546"
import script from "./ProjectMembers.vue?vue&type=script&lang=js"
export * from "./ProjectMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=9dc5d546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports